import { render, staticRenderFns } from "./UnknownCardIcon.vue?vue&type=template&id=8ae412f4&"
import script from "./UnknownCardIcon.vue?vue&type=script&lang=js&"
export * from "./UnknownCardIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports